/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosStatusNotificationConfiguration } from '../../models/pos-status-notification-configuration';

export interface UpsertPosStatusNotification$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: PosStatusNotificationConfiguration
}

export function upsertPosStatusNotification(http: HttpClient, rootUrl: string, params: UpsertPosStatusNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PosStatusNotificationConfiguration>>> {
  const rb = new RequestBuilder(rootUrl, upsertPosStatusNotification.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PosStatusNotificationConfiguration>>;
    })
  );
}

upsertPosStatusNotification.PATH = '/stores/{storeId}/pos-status-notification';
